import React from "react";
import Pagination from "../../components/layout/Pagination";
import InputField from "../../components/layout/InputField";
import { CSVTablePaginationProps } from "../../interfaces";

const CSVTablePagination: React.FC<CSVTablePaginationProps> = ({
  currentPage,
  totalCount,
  limit,
  pageLimitOptions,
  onPageChange,
  onLimitChange,
}) => {
  return (
    <div className="users-pagination">
      <Pagination onPageChange={onPageChange} currentPage={currentPage} pageCount={Math.ceil(totalCount / limit)} />
      <div className="d-flex align-items-center">
        <div className="pagination-display paginationItemsSelect">
          <p className="m-0">
            {(currentPage - 1) * limit + 1} to {Math.min(currentPage * limit, totalCount)} of {totalCount}
          </p>
          <div className="divider"></div>
          <label>Display</label>
          <InputField
            label=""
            inputtype="select"
            selectItems={pageLimitOptions.filter((item) => item.value !== limit)}
            inputid="limit"
            placeholder={limit.toString()}
            inputMethod={(value) => {
              onLimitChange(parseInt(value));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CSVTablePagination;
